// frontend/src/utils/referralRef.js
// Purpose: Persist referral ref from URL (e.g. ?ref=share) for attribution on register.
// Aligns with docs/plans/active/REFERRAL_SOURCE_PLANNING.md and backend VALID_REFERRAL_SOURCES.

const REFERRAL_REF_STORAGE_KEY = "alertique_referral_ref";

/** Whitelist must match backend app.py VALID_REFERRAL_SOURCES. */
const VALID_REFERRAL_SOURCES = [
  "telegram",
  "organic",
  "direct",
  "social",
  "email",
  "web",
  "share",
];

/**
 * Get the stored referral ref from sessionStorage (set when user landed with ?ref=...).
 * @returns {string|null} Valid ref value or null.
 */
export function getStoredReferralRef() {
  try {
    const stored = sessionStorage.getItem(REFERRAL_REF_STORAGE_KEY);
    if (stored && VALID_REFERRAL_SOURCES.includes(stored)) {
      return stored;
    }
  } catch (_) {
    // sessionStorage not available (e.g. private mode)
  }
  return null;
}

/**
 * Parse search string (e.g. window.location.search) for ref= and persist if valid.
 * Call on app/route load so that ?ref=share (and other refs) are stored for register.
 * @param {string} searchString - e.g. location.search or searchParams.toString()
 */
export function setReferralRefFromSearch(searchString) {
  if (!searchString || typeof searchString !== "string") return;
  try {
    const params = new URLSearchParams(searchString);
    const ref = params.get("ref");
    if (ref && VALID_REFERRAL_SOURCES.includes(ref)) {
      sessionStorage.setItem(REFERRAL_REF_STORAGE_KEY, ref);
    }
  } catch (_) {
    // ignore
  }
}

/**
 * Clear stored referral ref (e.g. after successful register if desired).
 * Not required for attribution; backend stores referral_source on user.
 */
export function clearReferralRef() {
  try {
    sessionStorage.removeItem(REFERRAL_REF_STORAGE_KEY);
  } catch (_) {
    // ignore
  }
}
